exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lbaKeyValuePairs_list{margin:1rem 0}.lbaKeyValuePairs_uiSelect{display:inline-block;width:30rem;margin:0 1rem 0 0}.lbaKeyValuePairs_uiSelect .form-control{width:100%}", "", {"version":3,"sources":["/../../../../../sassjs-loader/index.js!/home/vsts/work/1/s/src/components/lbaKeyValuePair/lbaKeyValuePairs.scss"],"names":[],"mappings":"AAAA,uBACE,aAAe,CAAE,AAEnB,2BACE,qBAAsB,AACtB,YAAa,AACb,iBAAmB,CAAE,AACrB,yCACE,UAAY,CAAE","file":"lbaKeyValuePairs.scss","sourcesContent":[".lbaKeyValuePairs_list {\n  margin: 1rem 0; }\n\n.lbaKeyValuePairs_uiSelect {\n  display: inline-block;\n  width: 30rem;\n  margin: 0 1rem 0 0; }\n  .lbaKeyValuePairs_uiSelect .form-control {\n    width: 100%; }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sassjs-loader!./src/components/lbaKeyValuePair/lbaKeyValuePairs.scss
// module id = 296
// module chunks = 0